module.exports = __webpack_public_path__ + "img/aParty_121223_G.d30e861e.jpg";